import * as React from "react";
export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.367 2.132a.75.75 0 011.266 0l3.773 5.929 3.928-4.256c.502-.544 1.405-.11 1.293.622L20 15H4L2.373 4.427c-.112-.731.79-1.166 1.293-.622L7.594 8.06l3.773-5.928zM6.484 9.806L4.972 8.169l.497 3.23 1.015-1.593zM6.822 13l1.065-1.674L9.432 13h-2.61zm2.176-3.42L12 4.864l3.002 4.718L12 12.833 8.998 9.581zm5.57 3.42l1.545-1.674L17.178 13h-2.61zm2.948-3.194L18.53 11.4l.497-3.231-1.51 1.637z"
      fill="currentColor"
    />
    <path
      d="M4 19h16v2H4v-2zM20 18a1 1 0 110-2v2zM5 17a1 1 0 00-1-1v2a1 1 0 001-1zM8 18a1 1 0 100-2 1 1 0 000 2zM13 17a1 1 0 11-2 0 1 1 0 012 0zM16 18a1 1 0 100-2 1 1 0 000 2z"
      fill="currentColor"
    />
  </svg>
);
